/**
 * The job's scope as plain lines (jobs.summary).
 *
 * A job made from a quote carries one plain line per device —
 * `Repair 3/4" Watts 009M3 SN: 123466 with complete rebuild kit, and test
 * after repair.` (server: services/repairScopeLines.ts). The office can still
 * write the summary in Markdown, so the iPad, the Grid hover and the office
 * card read it through this one helper: one line per line, bullets and
 * bold/italic markers dropped, blank lines skipped. Just the lines.
 */
export function scopeLines(summary: string | null | undefined): string[] {
    return (summary ?? "")
        .split(/\r?\n/)
        .map((l) =>
            l
                .replace(/^\s*(?:[-*+•]|\d+[.)])\s+/, "")
                .replace(/^\s*#{1,6}\s+/, "")
                .replace(/(\*\*|__)(.+?)\1/g, "$2")
                .replace(/(^|\s)[*_](\S(?:.*?\S)?)[*_](?=\s|$|[.,;:!?])/g, "$1$2")
                .trim(),
        )
        .filter((l) => l.length > 0);
}

/**
 * Markdown joins single newlines into one paragraph, which runs the scope's
 * device lines together. Keep each line on its own line when rendering.
 */
export function keepLineBreaks(markdown: string): string {
    return markdown.replace(/([^\n])\n(?!\n|\s*(?:[-*+]|\d+[.)])\s)/g, "$1  \n");
}

/** The pasted-quote note older repair jobs carry ("Scope (from estimate N):"). */
export function isPastedQuoteNote(body: string | null | undefined): boolean {
    return /^\s*Scope \(from estimate [^)]*\):/.test(body ?? "");
}
